/**
 * @generated SignedSource<<7f952c67e8e5d9f5d497fc4e6a8bee62>>
 * @relayHash f719f2a908e6567fd36ed4c89b999237
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f95fc3708e593753daaa0ae2b1073114d1aeebd173d388a6bb1f1499466cd297

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PlaybookLogsQuery } from './PlaybookLogsQuery.graphql';

const node: PreloadableConcreteRequest<PlaybookLogsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f95fc3708e593753daaa0ae2b1073114d1aeebd173d388a6bb1f1499466cd297",
    "metadata": {},
    "name": "PlaybookLogsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
